import React from "react";

const DropDownWithOutline = ({ width, height, fill, style, onClick }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.0078 13.1851L14.0078 9.18506H6.00781L10.0078 13.1851ZM10.0078 20.1851C8.62448 20.1851 7.32448 19.9226 6.10781 19.3976C4.89115 18.8726 3.83281 18.1601 2.93281 17.2601C2.03281 16.3601 1.32031 15.3017 0.795313 14.0851C0.270312 12.8684 0.0078125 11.5684 0.0078125 10.1851C0.0078125 8.80173 0.270312 7.50173 0.795313 6.28506C1.32031 5.06839 2.03281 4.01006 2.93281 3.11006C3.83281 2.21006 4.89115 1.49756 6.10781 0.972559C7.32448 0.447559 8.62448 0.185059 10.0078 0.185059C11.3911 0.185059 12.6911 0.447559 13.9078 0.972559C15.1245 1.49756 16.1828 2.21006 17.0828 3.11006C17.9828 4.01006 18.6953 5.06839 19.2203 6.28506C19.7453 7.50173 20.0078 8.80173 20.0078 10.1851C20.0078 11.5684 19.7453 12.8684 19.2203 14.0851C18.6953 15.3017 17.9828 16.3601 17.0828 17.2601C16.1828 18.1601 15.1245 18.8726 13.9078 19.3976C12.6911 19.9226 11.3911 20.1851 10.0078 20.1851ZM10.0078 18.1851C12.2411 18.1851 14.1328 17.4101 15.6828 15.8601C17.2328 14.3101 18.0078 12.4184 18.0078 10.1851C18.0078 7.95173 17.2328 6.06006 15.6828 4.51006C14.1328 2.96006 12.2411 2.18506 10.0078 2.18506C7.77448 2.18506 5.88281 2.96006 4.33281 4.51006C2.78281 6.06006 2.00781 7.95173 2.00781 10.1851C2.00781 12.4184 2.78281 14.3101 4.33281 15.8601C5.88281 17.4101 7.77448 18.1851 10.0078 18.1851Z"
        fill={fill}
      />
    </svg>
  );
};

DropDownWithOutline.defaultProps = {
  width: 20,
  height: 21,
  fill: "#1C1B1F",
};

export default DropDownWithOutline;
